import React, {useContext} from 'react';
import {sideMenuContext} from "../../../router/IndexRouter";
import {Button} from "antd";
import "../../../components/sandbox/index.css"

const PolicyDetail = () => {
    const {currentItem} = useContext(sideMenuContext);
    return (
        <div>
            <div className="panel panel-default mt-20">
                <div className="panel-header">政策法规内容</div>
            </div>
            <h2 style={{textAlign: "center"}}><b>{currentItem?.title}</b></h2>
            <h3 style={{float: "right", marginRight: 20}}>通知日期: {currentItem?.publishDate}</h3>
            <br/>
            <h3><b>详情内容：</b></h3>
            <div dangerouslySetInnerHTML={{ __html: currentItem?.policyContent}} />
            <hr style={{backgroundColor: "blue", height: "1px", border: "none", marginBottom: 15}}/>
            <Button htmlType="button" type="primary" onClick={()=>{window.history.back()}} style={{marginLeft: 8}}>返回</Button>
        </div>
    );
};

export default PolicyDetail;
